import { post } from "api/ky";
import { SetAuthPasswordSubmitData } from "components/SetPasswordView/SetPasswordView";
import config from "config/config";
import { ILoginSubmitData, ISignupSubmitData } from "models/User";

const AUTH_URL = config.authUrl;
const AUTH_API_VERSION = config.authApiVersion;

export const CREATE_USER_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/users`;
export const LOGIN_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/auth/login`;
export const LOGOUT_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/auth/logout`;
export const REFRESH_ACCESS_TOKEN_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/auth/refresh`;
export const CREATE_PASSWORD_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/users/password`;
export const RESET_PASSWORD_URL = `${AUTH_URL}/api/${AUTH_API_VERSION}/users/begin-password-reset`;

export interface IResetPasswordSubmitData {
  email: string;
  languageCode: string;
}

export const authCreateUser = async (signupSubmitData: ISignupSubmitData) => {
  const { email, password } = signupSubmitData;
  return await post(CREATE_USER_URL, { email, password }, { authRetryEnabled: false });
};

export const authLogin = async (loginViewSubmitData: ILoginSubmitData) => {
  return await post(LOGIN_URL, loginViewSubmitData, { authRetryEnabled: false });
};

export const authLogout = async () => {
  return await post(LOGOUT_URL, {}, { authRetryEnabled: false });
};

export const refreshAccessToken = async () => {
  return await post(REFRESH_ACCESS_TOKEN_URL, {}, { authRetryEnabled: false });
};

export const createPassword = async (data: SetAuthPasswordSubmitData) => {
  return await post(CREATE_PASSWORD_URL, data, { authRetryEnabled: false });
};

export const resetPassword = async (resetPasswordSubmitData: IResetPasswordSubmitData) => {
  return await post(RESET_PASSWORD_URL, resetPasswordSubmitData, {
    authRetryEnabled: false,
    snakecaseKeysOption: false,
  });
};
